import cx from "classnames";
import React, { CSSProperties } from "react";
import { Empty } from "shared/ui/empty";
import { LoadingDots } from "shared/ui/loading-dots";
import styles from "./list.module.scss";

export interface IListData<Data> {
  data?: Array<Data>;
  error?: unknown;
  isLoading?: boolean;
  mutate?: () => void;

  empty?: React.ReactNode;
}

export interface IList<Data> extends IListData<Data> {
  renderItem?: (data: Data) => React.ReactNode;

  header?: React.ReactNode;
  footer?: React.ReactNode;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const List = <Data extends { id?: string }>(props: IList<Data>) => {
  if (props.isLoading && !props.error && !props.data) {
    return (
      <div className={cx(styles.list, props.className)} style={props.style} id={props.htmlId}>
        <div className={styles.loading}>
          <LoadingDots size={10} />
        </div>
      </div>
    );
  }

  if (props.data?.length === 0) {
    return (
      <div className={cx(styles.list, props.className)} style={props.style} id={props.htmlId}>
        {props.empty || <Empty title="Нет данных" />}
      </div>
    );
  }

  if (!props.data && props.error) {
    return (
      <div className={cx(styles.list, props.className)} style={props.style} id={props.htmlId}>
        <Empty
          title="Ошибка загрузки"
          description={
            <pre>
              <code>{JSON.stringify(props.error, null, 2)}</code>
            </pre>
          }
        />
      </div>
    );
  }

  return (
    <div className={cx(styles.list, props.className)} style={props.style} id={props.htmlId}>
      {props.header}
      {props.data?.map((it, key) => (
        <React.Fragment key={it.id || key}>{props.renderItem?.(it)}</React.Fragment>
      ))}
      {props.footer}
    </div>
  );
};

List.defaultProps = {
  renderItem: (props: any) => (
    <pre>
      <code>{JSON.stringify(props, null, 2)}</code>
    </pre>
  ),
};
